import { AppShell, Group, Image, Title } from '@mantine/core'
import { FC } from 'react'
import * as classes from './TopBar.module.css'

const TopBar: FC<{ orgDisplayName: string }> = ({ orgDisplayName }) => {
  return (
    <AppShell.Header p="xs" className={classes.header}>
      <Group pl="md" wrap="nowrap">
        <Title order={2} style={{ textTransform: 'capitalize' }}>
          {orgDisplayName}
        </Title>
      </Group>
    </AppShell.Header>
  )
}

export default TopBar
